import React, { useEffect, useState } from 'react';
import { toast } from 'react-hot-toast';
import { v4 } from 'uuid';
import { Modal, ModalBody } from 'reactstrap';

import {
  Container,
  ComplementsTable,
} from './styles';
import api from '~/services/api';
import { useInView } from 'react-intersection-observer';
import EditComplement from './Edit';
import { useAuth } from '~/context/AuthContext';
import ComplementsRow from './ComplementsRow';

function Complements({
  category,
  getCategories,
  count,
  setCount,
  menewProducts,
  allCategories,
  setProductsCategories,
  productsCategories,
  setCategories,
  complementCategories,
  fiscalGroups,
  ifoodMenus,
  ifoodRestaurants,
  ifoodProducts,
}) {
  const { user: restaurant } = useAuth();

  const [modalEditComplement, setModalEditComplement] = useState(false);
  const [modalEditComplementData, setModalEditComplementData] = useState();

  function toggleModalEditComplement() {
    setModalEditComplement(!modalEditComplement);
  }

  function handleChangeEditComplement(complement) {
    toggleModalEditComplement();
    setModalEditComplementData(complement);
  }

  async function handleDelete(id) {
    try {
      if (
        window.confirm(
          'Tem certeza que deseja deletar este Complemento? Lembre-se que ele será excluído de todas as categorias. Para deletar desta categoria, clique em "Adicionar/ Remover complementos já existentes"'
        )
      ) {
        await api.delete(`/restaurants/product/complements/${id}`);
        localStorage.setItem('@gddashboard:isMenuUpdated', true);

        const newCategories = [...allCategories];

        const categoryFind = newCategories.findIndex(
          (item) => item.id === category.id
        );

        if (categoryFind !== -1) {
          const complementsFiltrered = newCategories[
            categoryFind
          ].complements.filter((item) => item.id !== id);

          newCategories[categoryFind].complements = [
            ...(newCategories[categoryFind].complements = complementsFiltrered),
          ];
        }

        setCategories(newCategories);

        toast.success('Complemento deletado com sucesso!');
      }
    } catch (error) {
      toast.error('Erro ao deletar complemento');
    }
  }

  async function handleChangeComplement(value, event, idx) {
    try {
      const [type, compId] = idx.split('-');
      const id = Number(compId);

      const data = {};

      if (type === 'pdv') {
        data.available = value;

        const newComplementsCategories = [...allCategories];

        newComplementsCategories.map((cat, idix) =>
          cat.complements.map((compl, idex) => {
            if (compl.id === id) {
              newComplementsCategories[idix].complements[
                idex
              ].available = value;
            }
          })
        );

        setCategories(newComplementsCategories);
      } else {
        data.available_in_delivery = value;
        const newComplementsCategories = [...allCategories];

        newComplementsCategories.map((cat, idix) =>
          cat.complements.map((compl, idex) => {
            if (compl.id === id) {
              newComplementsCategories[idix].complements[
                idex
              ].available_in_delivery = value;
            }
          })
        );

        setCategories(newComplementsCategories);
      }

      await api.put(`/restaurants/product/complements/${id}`, data);

      const aleatoryId = v4();

      setCount(aleatoryId);

      // getComplements();
      localStorage.setItem('@gddashboard:isMenuUpdated', true);
    } catch (error) {
      toast.error('Erro ao ativar/ desativar complemento');
      console.log(error.message);
    }
  }

 const [visibleComplements, setVisibleComplements] = useState(15); // começa com 20

  const { ref, inView } = useInView({
    threshold: 0,
  });

  useEffect(() => {
    if (inView) {
      setVisibleComplements(prev => prev + 15); // carrega +20 complementos
    }
  }, [inView]);

  const complementList = category?.complements?.slice(0, visibleComplements);

  return (
      <Container>
        <ComplementsTable>
          <thead>
            <tr>
              <th>Imagem</th>
              <th>Complemento</th>

              <th>Preço</th>
              <th>iFood</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {complementList?.map((item, index) => (
                <ComplementsRow
                  complement={item}
                  handleDelete={handleDelete}
                  handleChangeComplement={handleChangeComplement}
                  handleChangeEditComplement={handleChangeEditComplement}
                  index={index}
                  key={item.id}
                  user={restaurant}
                  complementsData={category?.complements}
                  setProductsCategories={setProductsCategories}
                  productsCategories={productsCategories}
                  category={category}
                  setCategories={setCategories}
                  categories={allCategories}
                  ifoodMenus={ifoodMenus}
                  ifoodRestaurants={ifoodRestaurants}
                  ifoodProducts={ifoodProducts}
                />
              ))}

                <tr>
              <td colSpan="5">
                <div ref={ref} style={{ height: 40 }} />
              </td>
            </tr>
          </tbody>

          <Modal
            isOpen={modalEditComplement}
            toggle={toggleModalEditComplement}
            size="xl"
          >
            <ModalBody>
              <EditComplement
                complement={modalEditComplementData}
                getCategories={getCategories}
                toggleModal={toggleModalEditComplement}
                getComplements={false}
                setCount={setCount}
                menewProducts={menewProducts}
                allCategories={allCategories}
                setProductsCategories={setProductsCategories}
                productsCategories={productsCategories}
                categories={complementCategories}
                setCategories={setCategories}
                fiscalGroups={fiscalGroups}
                category={category}
              />
            </ModalBody>
          </Modal>
        </ComplementsTable>
      </Container>
  );
}

export default Complements;
